export const serviceOpsTasksConstants = {
    LOADING: 'SERVICEOPS_LOADING',
    UPDATE_TASKS_TABLE: 'SERVICEOPS_UPDATE_TASKS_TABLE',
    UPDATE_CHANGE_TRIGGER: 'SERVICEOPS_UPDATE_CHANGE_TRIGGER'
};